import { lazy } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RootLayout from "./components/layouts/RootLayout";
import Home from "./pages/Home";
import PublicHome from "./pages/PublicHome";

let hasReloaded = false;

const UpdatingMessage = () => <span></span>;

const safeImport = (importFn: any) =>
  lazy(() =>
    importFn().catch((err: any) => {
      console.error("❌ Failed to load module:", err);

      if (!hasReloaded) {
        hasReloaded = true;
        console.log("🔄 Forcing a one-time reload...");
        window.location.reload();
      }

      return { default: UpdatingMessage };
    })
  );

const Edit = safeImport(() => import("./pages/Edit"));

const router = createBrowserRouter([
  {
    path: "/public",
    element: <RootLayout />,
    children: [
      {
        path: "",
        element: <PublicHome />,
      },
      {
        path: ":page_id",
        element: <PublicHome />,
      },
    ],
  },
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: ":page_id",
        element: <Home />,
      },
      {
        path: ":page_id/edit",
        element: <Edit />,
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
